<template>
  <InfoBox
    status="debug"
    text=" Kredi Kartı Numarası : 5526080000000006 
      12/26 123"
  />

  <PaymentWidget
    :order="createdOrder"
    :isYearly="props.isYearly"
    @payment-success="onSuccessfulPayment"
    @payment-error="onPaymentError"
  />
</template>

<script setup>
import { defineProps, ref } from "vue";
import { useRouter } from "vue-router";
import InfoBox from "../dashboard-components/InfoBox.vue";
import PaymentWidget from "@/components/PaymentWidget.vue";

const router = useRouter();
const subscriptionId = ref(null);

// Prop olarak gelen createdOrder
const props = defineProps({
  createdOrder: {
    type: Object,
    required: true,
  },
  isYearly: {
    type: Boolean,
    required: true,
  },
});

const onSuccessfulPayment = (paymentResult) => {
  subscriptionId.value = paymentResult.SubscriptionId;
  router.push({
    name: "domain-selection",
    query: { subscriptionId: subscriptionId.value },
  });
};

const onPaymentError = (error) => {
  // PaymentWidget already shows the error toast
  console.error("Payment error:", error);
};
</script>

<style scoped>
.step-four {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

@media (min-width: 1024px) {
  .step-four {
    flex-direction: row;
  }
}

.payment-section,
.order-summary {
  flex: 1;
}

.input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.375rem;
}

.btn-primary {
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  text-align: center;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
}

.btn-primary:hover {
  background-color: #0056b3;
}
</style>
